module.exports = __webpack_public_path__ + "img/portrait-076.5cf41599.jpg";